<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "ruihong",
    data() {
        return {
            
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {
    },
    activated(){
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        this.recalc();
        window.addEventListener(resizeEvt, this.recalc, false);
        document.addEventListener('DOMContentLoaded', this.recalc, false);
    },
    watch: {},
    methods: {
        recalc(){
            var docEl = document.documentElement;
            var clientWidth = docEl.clientWidth;
            var clientHeight = docEl.clientHeight;
            if (!clientWidth) return;
            if (clientWidth < 1024) {
                docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
                if(this.$route.path != '/h5/rhca/mobile'){
                    this.$router.replace('/h5/rhca/mobile')
                }
            } else {
                docEl.style.fontSize = 100 * (clientWidth / 1920) + 'px';
                if(this.$route.path != '/h5/rhca'){
                    this.$router.replace('/h5/rhca')
                }
            }
        },
    },
    deactivated(){
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.removeEventListener(resizeEvt, this.recalc);
        document.removeEventListener('DOMContentLoaded', this.recalc);
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">

</style>